
import { graphql as gql } from 'react-relay';
const graphql = gql;

export const ChangeCurrencyMutation = graphql`
  mutation currency_Mutation($input: ChangeCurrencyInput!) {
    changeCurrency(input: $input) {
      viewer {
        id
        selected_currency
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/currency.ts